export default {"src":"/_next/static/media/Tennessee.7a851033.svg","height":157,"width":800,"blurWidth":0,"blurHeight":0};